import React,{useState} from "react";
import Tooltip from "@mui/material/Tooltip";
import { Zoom } from "@mui/material";
import DeleteQuestionModal from  "../../modals/DeleteQuestionModal.jsx";
import { normalizeQuestion } from "../../../utils/questionNormalizer.js";


function McqQuestionsRenderer({
  handleMcqQuestionsEdit,
  handleMcqQuestionDelete,
  handleMcqQuestionChange,
  handleOptionEdit,
  handleOptionChange,
  handleOptionBlur,
  editingOptionIndices,
  question,
  index,
}) {

  const normalizedQuestion = normalizeQuestion(question, "mcq");
   const [showDeleteModal, setShowDeleteModal] = useState(false);

   const stripReference = (ans) => {
    if (!ans || typeof ans !== "string") return ans;
    // remove trailing parentheses that start with Reference/Ref/Source (case-insensitive)
    return ans.replace(/\s*\((?:Reference|Ref|Source)[^)]+\)\s*$/i, "").trim();
  };

  const cleanedAnswer = stripReference(question?.Answer);

   // Handler for opening delete modal
  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

    // Handler for confirming delete
  const handleConfirmDelete = () => {
    handleMcqQuestionDelete(normalizedQuestion.index);
  };
  return (
    <>
      {/* {mcqsQuestions.map((mcqQuestion, index) => ( */}
      <div className="mb-4 border-slate-100 hover:border-[#f4833d] border-2 hover:border-dotted rounded question-answer-container p-4">
        <div className="flex place-content-between">
          {/* Questions goes here */}
          <div className="flex">
            <span>{index + 1}.&nbsp; </span>{" "}
           {question.editing ? (
              <div
                contentEditable="true"
                id={`question-${index}`}
                className="wh-question-editable "
                onBlur={(e) => {
                  handleMcqQuestionChange(normalizedQuestion.index, e.target.textContent);
                  handleMcqQuestionsEdit(normalizedQuestion.index);
                }}
                dangerouslySetInnerHTML={{ __html: normalizedQuestion.question }}
              />
            ) : (
              <span
                onClick={() => handleMcqQuestionsEdit(normalizedQuestion.index)}
                className="cursor-pointer"
                dangerouslySetInnerHTML={{ __html: normalizedQuestion.question }}
              />
            )}
          </div>

          <div className="flex edit-delete-icons">
            {/* Edit Icon */}
            <Tooltip
              title="Edit"
              arrow
              placement="top"
              TransitionComponent={Zoom}
              TransitionProps={{ timeout: 300 }}
            >
              <button
                onClick={() => handleMcqQuestionsEdit(normalizedQuestion.index)}
                className="text-indigo-500 mr-2"
              >
                <i className="fa-solid fa-pen-to-square"></i>{" "}
              </button>
            </Tooltip>

            {/* Delete Icon */}
            <Tooltip
              title="Delete"
              arrow
              placement="top"
              TransitionComponent={Zoom}
              TransitionProps={{ timeout: 300 }}
            >
              <button
                onClick={() => handleDeleteClick()}
                className="text-red-500"
              >
                <i className="fa-solid fa-trash"></i>{" "}
              </button>
            </Tooltip>
          </div>
        </div>

        <div className=" p-2 rounded">
          {/* Options goes here */}
          {question?.Options?.map((option, optionIndex) => (
            <div
              key={optionIndex}
              className={`w-2/3 p-2 mb-1 rounded ${
                // option === question.Answer ? "bg-[#c0f0e2]" : "bg-[#fdecf6]"
                option === cleanedAnswer ? "bg-[#c0f0e2]" : "bg-[#fdecf6]"
              }`}
            >

              {editingOptionIndices[index] === optionIndex ? (
                <input
                  type="text"
                  value={option}
                  // ref={(inputRef) => inputRef && inputRef.focus()}
                  className="w-full "
                  onChange={(e) =>
                    handleOptionChange(
                      normalizedQuestion.index,
                      optionIndex,
                      e.target.value
                    )
                  }
                  onBlur={() => handleOptionBlur(normalizedQuestion.index)}
                />
              ) : (
                <span
                  className="cursor-pointer"
                  onClick={() => handleOptionEdit(normalizedQuestion.index, optionIndex)}
                >
                  {option}
                </span>
              )}
            </div>
          ))}
        </div>

        {/* Correct Answer */}
        <p>
          <strong>Answer:</strong> {cleanedAnswer || question.Answer}
        </p>
      </div>
        <DeleteQuestionModal
          open={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirmDelete={handleConfirmDelete}
          questionNumber={index + 1}
        />
    </>
  );
}

export default McqQuestionsRenderer;
